export default __webpack_public_path__ + "static/media/radio-en-full.2df466b7.svg";